<template>
  <div class="flex items-center space-x-2 overflow-hidden bg-gray-300">
    <input class="py-1 px-2 text-black" type="search" v-model="filter.name" placeholder="search" @focus="$event.target.select()" />
    <div class="relative self-stretch flex-1 overflow-hidden ">
      <div class="absolute inset-y-0 left-0 flex items-center space-x-3">
        <div class="flex items-center space-x-1 cursor-pointer hover:opacity-75" :class="filter.language ? (filter.language === country.name ? 'opacity-100' : 'opacity-25') : 'opacity-100'" v-for="country in channelCountries" :key="country.name" @click="toggleLanguageFilter(country.name)">
          <UiFlag class="flag-lg rounded-sm" :country="country.name" />
          <div class="text-sm font-bold">{{ country.count }}</div>
        </div>
      </div>
      <div class="absolute inset-y-0 right-0 w-32 bg-gradient-to-r from-transparent to-gray-300 pointer-events-none"></div>
    </div>
    <!-- <div class="flex items-center space-x-1" v-if="filter.language">
      <UiFlag class="flag-lg cursor-pointer hover:brightness-10" :country="filter.language" />
      <div title="Clear filter" class="cursor-pointer text-sm text-gray-600 hover:text-red-600" @click="filter.language = null">✖</div>
    </div> -->
  </div>
</template>

<script>
  //import { computed } from 'vue'
  import { config, filter, channelCountries } from '@/store'
  //import Languages from '@/components/Languages'

  export default {
    name: 'MainFilter',
    components: {
      // Languages,
    },
    setup() {
      function toggleLanguageFilter(country) {
        filter.language = filter.language === country ? null : country
      }

      return { config, filter, channelCountries, toggleLanguageFilter }
    },
  }
</script>
